module.exports = __webpack_public_path__ + "img/hippocrates_logo.86d3bea6.png";